export const SCHWAB_ONE_PERSONAL = {
  DISPLAY: 'Schwab One® Personal',
  RAW_TYPE: 'Schwab One Brokerage - Personal',
  ACCOUNT_TYPE_ROUTE: 'schwab_one_personal',
  SECTION: 'schwabOnePersonalSection',
  ACCOUNT_TYPES: {
    UTMA: 'UTMA',
  }
}

export const SCHWAB_ONE_TRUST = {
  DISPLAY: 'Schwab One® Trust',
  RAW_TYPE: 'Schwab One Brokerage - Trust',
  ACCOUNT_TYPE_ROUTE: 'schwab_one_trust',
  SECTION: 'schwabTrustSection',
}

export const SCHWAB_IRA = {
  DISPLAY: 'IRA Account',
  RAW_TYPE: 'Schwab IRA Account',
  ACCOUNT_TYPE_ROUTE: 'schwab_ira',
  SECTION: 'schwabIraSection',
  ACCOUNT_TYPES: {
    SEP_IRA: 'SEP-IRA',
    SIMPLE_IRA: 'SIMPLE IRA',
    TRADITIONAL_IRA: 'Traditional IRA',
    ROTH_IRA: 'Roth IRA',
    CUSTODIAL_IRA: 'Custodial IRA',
    CUSTODIAL_ROTH_IRA: 'Custodial Roth IRA',
    INHERITED_IRA: 'Inherited IRA',
    INDIVIDUAL_401K: 'Individual 401(k)',
  },
  EFFECTIVE_DATE_CONFIG: {
    INITIAL_ADOPTION: 'Initial Adoption',
    AMENDMENT_AND_RESTATEMENT: 'Amendment and Restatement'
  }
}

export const SCHWAB_CHARITABLE = {
  DISPLAY: 'Schwab Charitable',
  RAW_TYPE: 'Schwab Charitable',
  ACCOUNT_TYPE_ROUTE: 'schwab_charitable',
  SECTION: 'schwabCharitableSection',
  ACCOUNT_TYPES: {
    DONOR_ADVISED_FUND: 'Donor Advised Fund'
  },
}

export const allFinancialAccountTypes = {
  schwab_one_personal: SCHWAB_ONE_PERSONAL,
  schwab_ira: SCHWAB_IRA,
  schwab_one_trust: SCHWAB_ONE_TRUST,
  schwab_charitable: SCHWAB_CHARITABLE,
}

export const rawToRouteTypeTranslate = () => {
  const rawToRouteType = {}
  Object.keys(allFinancialAccountTypes).forEach((t) => {
    const type = allFinancialAccountTypes[t]
    const { RAW_TYPE, ACCOUNT_TYPE_ROUTE } = type
    rawToRouteType[RAW_TYPE] = ACCOUNT_TYPE_ROUTE
  })

  return rawToRouteType
}

export const rawFinancialAccountTypes = rawToRouteTypeTranslate() 

export const isValidFinancialAccountType = accountType => (
  !!Object.keys(allFinancialAccountTypes).find(e => accountType === e)
)

const getSubTypeDisplay = (accountType, subType) => {
  let displaySubtype

  if (subType) {
    displaySubtype = Object.values(accountType.ACCOUNT_TYPES).find(at => at === subType)
  }

  return displaySubtype ? { ...accountType, DISPLAY: displaySubtype } : accountType
}

const getIRADisplay = subType => getSubTypeDisplay(SCHWAB_IRA, subType)

const getCharitableDisplay = subType => getSubTypeDisplay(SCHWAB_CHARITABLE, subType)

const getPersonalDisplay = subType => getSubTypeDisplay(SCHWAB_ONE_PERSONAL, subType)

export const getFinancialAccountData = (value, property = 'ACCOUNT_TYPE_ROUTE', subType = null) => {
  if (value === SCHWAB_ONE_PERSONAL[property]) {
    return getPersonalDisplay(subType)
  } else if (value === SCHWAB_ONE_TRUST[property]) {
    return SCHWAB_ONE_TRUST
  } else if (value === SCHWAB_IRA[property]) {
    return getIRADisplay(subType)
  } else if (value === SCHWAB_CHARITABLE[property]) {
    return getCharitableDisplay(subType)
  }
}

export const getAccountDisplayNameByType = (type, subType) => {
  const data = getFinancialAccountData(type, 'RAW_TYPE', subType)
  return (data && data.DISPLAY) || ''
}

export const shouldShowOnlyStandardSections = (currentFinancialAccount) => {
  if (currentFinancialAccount) {
    const {
      attributes: {
        financialAccountType
      }
    } = currentFinancialAccount
    const type = getFinancialAccountData(financialAccountType, 'RAW_TYPE')

    if (type === SCHWAB_IRA) {
      const { SEP_IRA, SIMPLE_IRA, INDIVIDUAL_401K } = SCHWAB_IRA.ACCOUNT_TYPES
      const { subType } = currentFinancialAccount.attributes
      if (![SEP_IRA, SIMPLE_IRA, INDIVIDUAL_401K].includes(subType)) {
        return true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/financialAccountTypes.js